import { AxiosError } from 'axios';
import { notification } from 'antd';

import { axiosErrorToString } from './axios-error-to-string';

export const showAxiosError = (err: AxiosError) => {
  const message = axiosErrorToString(err);
  notification.error({ message, duration: 8 });
};
